export default function getRefundsTaleFields(ctx) {
	return [
		{
			field: "date",
			title: ctx.$t("date"),
			align: "start"
		},
		{
			field: "order_id",
			title: ctx.$t("orderId") + " №",
			align: "center"
		},
		{
			field: "manager",
			title: ctx.$t("manager"),
			align: "center"
		},
		{
			field: "return_reason",
			title: ctx.$t("reason"),
			align: "center"
		},
		{
			field: "amount",
			title: ctx.$t("sumOfRefunds"),
			align: "center"
		},
		{
			field: "website",
			title: ctx.$t("site"),
			align: "center"
		}
	];
}
